<template>
  <v-card>
    <v-form v-model="formValid">
      <v-col
        cols="12"
      >
        <v-text-field
          v-model="form.name"
          label="Název typu stravy"
          required
          :rules="[rules.required]"
        ></v-text-field>
      </v-col>
      <v-col
        cols="6"
      >
        <v-checkbox v-model="form.active" label="Aktivní"></v-checkbox>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          :disabled="!formValid || wait"
          color="warning"
          class="mr-4"
          @click="save"
        >
          Zapsat
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
import rules from '../../../mixins/rules'

export default {
  name: 'FoodTypeForm',
  props: ['item'],
  mixins: [rules],
  data () {
    return {
      wait: false,
      formValid: true,
      form: {
        id: this.item.id,
        active: this.item.active,
        name: this.item.name
      }
    }
  },
  methods: {
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/food-types${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(res => {
          this.$emit('data-saved')
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>
